import { render, staticRenderFns } from "./insurer-rate-detail.vue?vue&type=template&id=4c3c6b7a&scoped=true&"
import script from "./insurer-rate-detail.vue?vue&type=script&lang=js&"
export * from "./insurer-rate-detail.vue?vue&type=script&lang=js&"
import style0 from "./insurer-rate-detail.vue?vue&type=style&index=0&id=4c3c6b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3c6b7a",
  null
  
)

export default component.exports